/* unplugin-vue-components disabled */import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/img/G.svg';
import _imports_1 from '@/assets/img/policy-stuff.svg';
import _imports_2 from '@/assets/img/claims.svg';
const _hoisted_1 = {
  class: "faq static-space-top pt-5"
};
const _hoisted_2 = {
  class: "faq-banner"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row gx-5"
};
const _hoisted_5 = {
  class: "col-lg-6 d-flex justify-content-center align-items-center"
};
const _hoisted_6 = {
  class: "d-flex flex-column justify-content-center"
};
const _hoisted_7 = {
  key: 1,
  href: "",
  class: "btn"
};
const _hoisted_8 = {
  class: "col-lg-6 text-center"
};
const _hoisted_9 = {
  class: "container overflow-hidden"
};
const _hoisted_10 = {
  class: "section-spacing faq-categories"
};
const _hoisted_11 = {
  class: "row gx-5"
};
const _hoisted_12 = {
  class: "col-xl-4 col-md-6"
};
const _hoisted_13 = {
  class: "category-card"
};
const _hoisted_14 = {
  class: "d-flex w-100 category-detail"
};
const _hoisted_15 = {
  class: "col-xl-4 col-md-6"
};
const _hoisted_16 = {
  class: "category-card"
};
const _hoisted_17 = {
  class: "d-flex w-100 category-detail"
};
const _hoisted_18 = {
  class: "col-xl-4 col-md-6"
};
const _hoisted_19 = {
  class: "category-card"
};
const _hoisted_20 = {
  class: "d-flex w-100 category-detail"
};
const _hoisted_21 = {
  class: "section-spacing faq-products"
};
const _hoisted_22 = {
  class: "insure__wrapper mb-3"
};
const _hoisted_23 = {
  class: "insure__header"
};
import CardsInsured from "@/components/header/cardsInsured";
import Searchforhelpcenter from "@/components/faq/searchForHelpCenter/searchForHelpCenter.vue";
import { useMeta } from "vue-meta";
import { track } from "@/analytics/events";
import { toRaw } from "@vue/reactivity";
import { uuid } from "vue-uuid";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
export default {
  __name: 'faqList',
  setup(__props) {
    const {
      useActions,
      useState
    } = createNamespacedHelpers("blogandFaq");
    const userStore = createNamespacedHelpers("user");
    const {
      user
    } = userStore.useState(["user"]);
    const activeTab = ref(1);
    const {
      fetchAllFaqs
    } = useActions(["fetchAllFaqs"]);
    const {
      status,
      allFaqs
    } = useState(["status", "allFaqs"]);
    fetchAllFaqs();
    const trackSegmentClick = event => {
      // code for segment
      track(`${event}`, {
        event_name: `${event}`
      });
    };
    const loading = computed(() => {
      return status.value == "pending" ? true : false;
    });
    useMeta({
      title: "FAQs"
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("template", null, [(_openBlock(), _createBlock(_Teleport, {
        to: "head"
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
        type: "application/ld+json"
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" { \"@context\": \"http://schema.org/\", \"@type\": \"WebSite\", \"name\": \"G1G Travel Insurance\", \"about\": \"G1G provides travel insurance for the conscious traveler, with smart quotes, flexible coverage, and claims advocacy. Our plans are designed for solo travelers, families, cruisers, and anyone who wants to travel safely. We offer #1 rated coverage by travelers like you, with a 4.9/5 star rating for customer satisfaction. Our AI-powered bot, ITIRA, helps you get an unbiased quote quickly and compare coverage from dozens of vetted providers. ITIRA recommends a plan specific to you, your trip, and your destination. With G1G Flex, you can cancel on your terms, and our dedicated Claims Advocacy team is free with every plan.\", \"audience\": \"Travelers, visitors, visitors to the USA, tourists, immigrants, green card holders, shoppers, value shoppers, cruise-goers, tour-goers, international students, technology enthusiasts, art and entertainment lovers, lifestyle enthusiasts, accommodations, financial planners, insurance agents, travel agencies, hotels, world nomads, travel nomads, nomads, expatriates, expats, au pairs, travel bloggers, backpackers, campers, extreme sports enthusiasts, adventurers, business travelers, and anyone interested in travel insurance.\", \"locationCreated\": \"San Jose, California\", \"mainEntity\": \"G1G\", \"keywords\": \"Travel insurance, visitor insurance, Medical emergencies, COVID-19 treatment, Emergency evacuation, Pre-existing conditions, Travel mishaps, Emergency dental care, Life insurance cruise insurance, flexible travel insurance, claims advocacy, cancel for any reason, COVID-19 treatment coverage, emergency evacuation, pre-existing conditions, emergency dental care, life insurance\", \"url\": \"https://www.g1g.com/\", \"potentialAction\": { \"@type\": \"SearchAction\", \"target\": \"https://www.g1g.com/?s={search_term_string}\", \"query-input\": \"required name=search_term_string\" }, \"hasPart\": [ { \"@type\": \"WebPage\", \"name\": \"G1G Help Center\", \"about\": \"G1G's Help Center provides information and support on travel insurance policies, claims, and more.\", \"hasPart\": [ { \"@type\": \"WebPage\", \"name\": \"About G1G\", \"about\": \"Learn about G1G and our commitment to providing smart quotes, flexible coverage, and claims advocacy for the conscious traveler.\" }, { \"@type\": \"WebPage\", \"name\": \"How is G1G different?\", \"about\": \"Discover what sets G1G apart from other travel insurance providers.\" }, { \"@type\": \"WebPage\", \"name\": \"Why buy from G1G?\", \"about\": \"Find out why G1G is the right choice for your travel insurance needs.\" }, { \"@type\": \"WebPage\", \"name\": \"Policy Stuff\", \"about\": \"Learn about G1G's policies and procedures, including how to extend a plan, cancel a policy, or make changes to your coverage.\" }, { \"@type\": \"WebPage\", \"name\": \"Claims\", \"about\": \"Get information on how to file a claim with G1G, how claims get paid, and how long it takes to receive payment.\" }, { \"@type\": \"WebPage\", \"name\": \"Travel protection insurance\", \"about\": \"Learn}]}} ")])),
        _: 1
      }))]))]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[13] || (_cache[13] = _createElementVNode("h1", {
        class: "mb-3"
      }, "G1G Help Center", -1)), _createVNode(Searchforhelpcenter), _createElementVNode("p", null, [!_unref(user) ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => trackSegmentClick('Login Clicked')),
        to: "/login",
        class: "btn"
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode(" Log in ")])),
        _: 1
      })) : (_openBlock(), _createElementBlock("a", _hoisted_7, " Welcome " + _toDisplayString(_unref(user).first_name), 1)), _cache[12] || (_cache[12] = _createElementVNode("span", null, " for personalized support. Get help with your reservations, account, and more.", -1))])])]), _createElementVNode("div", _hoisted_8, [_createVNode(CloudinaryImage, {
        alt: "Honesty in DNA img",
        class: "img-fluid w-100 help-center-img",
        imageName: "DOG_HELP_1_ocd0kj"
      })])])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "icon-outter sky"
      }, [_createElementVNode("div", {
        class: "icon"
      }, [_createElementVNode("img", {
        class: "img-fluid",
        src: _imports_0,
        alt: "about-category"
      })])], -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("h2", {
        class: "category-name"
      }, "About G1G", -1)), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "about-us",
        onClick: _cache[1] || (_cache[1] = $event => trackSegmentClick('About G1G'))
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("About G1G")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "blogs/the-mission-that-drives-us",
        onClick: _cache[2] || (_cache[2] = $event => trackSegmentClick('How is G1G different?'))
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("How is G1G different?")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "how-g1g-works-best-travel-insurance",
        onClick: _cache[3] || (_cache[3] = $event => trackSegmentClick('How does G1G work?'))
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("How does G1G work?")])),
        _: 1
      })])])])])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[22] || (_cache[22] = _createElementVNode("div", {
        class: "icon-outter yellow"
      }, [_createElementVNode("div", {
        class: "icon"
      }, [_createElementVNode("img", {
        class: "img-fluid",
        src: _imports_1,
        alt: "policy-category"
      })])], -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_cache[21] || (_cache[21] = _createElementVNode("h2", {
        class: "category-name"
      }, "Policy stuff", -1)), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "faq/can-you-extend-your-travel-insurance-policy",
        onClick: _cache[4] || (_cache[4] = $event => trackSegmentClick('How do I extend a plan?'))
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("How do I extend a plan?")])),
        _: 1
      })]), _createElementVNode("li", null, [_createElementVNode("a", {
        href: "/faq/can-visitors-insurance-be-canceled",
        onClick: _cache[5] || (_cache[5] = $event => trackSegmentClick('Can I cancel my policy?'))
      }, "Can I cancel my policy? ")]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "faq/how-can-you-make-changes-to-your-travel-insurance-plan",
        onClick: _cache[6] || (_cache[6] = $event => trackSegmentClick('How do I make a change to my plan?'))
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("How do I make a change to my plan?")])),
        _: 1
      })])])])])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "icon-outter green"
      }, [_createElementVNode("div", {
        class: "icon"
      }, [_createElementVNode("img", {
        class: "img-fluid",
        src: _imports_2,
        alt: "claims-category"
      })])], -1)), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_cache[26] || (_cache[26] = _createElementVNode("h2", {
        class: "category-name"
      }, "Claims", -1)), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "blogs/how-to-file-a-travel-insurance-claim-a-step-by-step-guide",
        onClick: _cache[7] || (_cache[7] = $event => trackSegmentClick('How do I file a claim?'))
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("How do I file a claim? ")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "blogs/how-do-travel-insurance-claims-get-paid",
        onClick: _cache[8] || (_cache[8] = $event => trackSegmentClick(' How do claims get paid?'))
      }, {
        default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode(" How do claims get paid? ")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "faq/understanding-travel-insurance-claim-processing-time-what-to-expect",
        onClick: _cache[9] || (_cache[9] = $event => trackSegmentClick('How fast do claims take?'))
      }, {
        default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("How fast do claims take?")])),
        _: 1
      })])])])])])])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[28] || (_cache[28] = _createElementVNode("h2", {
        class: "sec-title m-0"
      }, "Learn by product", -1)), _createVNode(_unref(CardsInsured))])])])])])], 64);
    };
  }
};